import React from 'react';
import { AppleLogo, GoogleG } from '~/components/WalletPicker';
import './styles.css';

const ICONS = {
  gpay: () => <GoogleG size={20} />,
  apay: () => <AppleLogo size={18} />,
  pix: () => <i className="las la-qrcode payment-alt-icon" />,
  card: () => <i className="las la-credit-card payment-alt-icon" />,
};

/**
 * Bloco exibido quando um pagamento falha: mensagem do erro + outras formas
 * de pagamento disponíveis. Usado inline no checkout e no estado de erro do
 * modal 3DS (compact = sem título/mensagem, o modal já os mostra).
 *
 * options: [{ key, label, hint, icon: 'gpay'|'apay'|'pix'|'card', onSelect }]
 */
export default function PaymentAlternatives({
  message,
  options = [],
  themeColor,
  compact = false,
}) {
  if (!options.length) return null;

  const accent = themeColor || '#2544b1';

  return (
    <div
      className={`payment-alt ${compact ? 'payment-alt-compact' : ''}`}
      style={{ '--payment-alt-accent': accent }}
    >
      {!compact && (
        <div className="payment-alt-head">
          <i className="las la-exclamation-circle payment-alt-head-icon" />
          <div>
            <div className="payment-alt-title">
              Não foi possível concluir o pagamento
            </div>
            {message && <div className="payment-alt-message">{message}</div>}
          </div>
        </div>
      )}

      <div className="payment-alt-label">Tente outra forma de pagamento:</div>

      <div className="payment-alt-options">
        {options.map(opt => {
          const Icon = ICONS[opt.icon] || ICONS.card;
          return (
            <button
              key={opt.key}
              type="button"
              className="payment-alt-option"
              onClick={opt.onSelect}
            >
              <span className="payment-alt-option-icon">
                <Icon />
              </span>
              <span className="payment-alt-option-text">
                <span className="payment-alt-option-label">{opt.label}</span>
                {opt.hint && (
                  <span className="payment-alt-option-hint">{opt.hint}</span>
                )}
              </span>
              <i className="las la-angle-right payment-alt-option-arrow" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
